import { render, staticRenderFns } from "./modalReportarReclamo.vue?vue&type=template&id=65250871&"
import script from "./modalReportarReclamo.vue?vue&type=script&lang=js&"
export * from "./modalReportarReclamo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports